<div *ngIf="exerciseData">
    <div class="row">
        <div class="col-3">
            <label>Name:</label>
        </div>
        <div class="col-8">
            {{exerciseData.name}}
        </div>
    </div>    
    
    <div class="row interactions-header my-2">
        <div class="col">
            <label>Interactions</label>
        </div>
    </div>
    <div class="interaction-row" *ngFor="let inter of exerciseData.interactions">
         <div class="row" [ngClass]="{'active': inter.refId==activeRefId}" 
              (click)="viewInteraction(inter.refId)">

            <div class="col-3">
                {{inter.refName}}
            </div>
            <div class="col-2">
                {{inter.block}}
            </div>
            <div class="col-4">
                {{inter.type}}
            </div>
            <div class="col-3">
                {{inter.refId}}
            </div>
    
         </div>
    </div>
    <div class="d-flex justify-content-end my-2" *ngIf="activeRefId">

        <button (click)="clearRefId()">Show exercise</button>
    </div>
</div>
